import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=9af2cdf4&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"
import style0 from "./notifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports